/**
 * Application route paths
 */
export enum Path {
  APP_MAIN = "/",
  IDO = "/ido/:idoId",
  DASHBOARD = "/dashboard",
  BUILD_KARMA = "/build_karma",
  BUILD_KARMA_SLASH = "/build_karma/",
  MYSTERY_BOX = "/mystery_box",
  CLAIM = "/claim",
  BRIDGE = "/bridge",
  REF_STATISTICS = "/ref_statistics",
  REF_STATISTICSBYID = "/ref_statistics/:idoId",
}
